module.exports = __webpack_public_path__ + "img/pic10.d0e292d7.png";